(ns manage.adset-decision-tree-page.view.side-panel.product-selector-editor
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Link$default" :as Link]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [common.queries :refer [use-query]]
            [common.resource.query.product-selector :as product-selector.q]
            [reitit.frontend.easy :as r.easy]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui ad-format-pane [{:keys [index dynamic-content]}]
  (let [product-selector-data
        (uix/use-memo
         (fn []
           (->> dynamic-content
                vals
                (filter #(= "products" (:source-type %)))
                (map :config)
                first))
         [dynamic-content])
        {:keys [product-selector-id placeholder]} product-selector-data
        {:keys [advertiser-id] :as url-context} (use-subscribe [:url-context])
        {selector-data :data} (use-query (product-selector.q/product-selector-query
                                          {:advertiser-id advertiser-id
                                           :product-selector-id product-selector-id}))
        selector-name (:name selector-data)
        {result-data :data} (use-query (product-selector.q/product-selector-result-query
                                        {:advertiser-id advertiser-id
                                         :product-selector-id product-selector-id}))
        total-products (get-in result-data [:meta :total])
        selector-href (r.easy/href :advertiser/product-selector
                                   url-context
                                   {:product-selector-id product-selector-id})]

    ($ Stack {:direction "column"
              :spacing 2
              :sx #js {:backgroundColor "background.paper"
                       :pl 0}
              :key index}

       ;; Product selector section
       ($ Stack {:direction "column"
                 :spacing 1.5
                 :sx #js {:pl 1}}

          ;; Product selector label and name with link icon
          ($ Stack {:direction "column"
                    :spacing 1}
             ($ Typography {:variant "body2"
                            :color "text.secondary"}
                "Product selector")
             ($ Stack {:direction "row"
                       :spacing 0.5
                       :alignItems "center"
                       :justifyContent "space-between"}
                ($ Typography {:variant "body1"
                               :color "text.primary"}
                   (or selector-name product-selector-id))
                ($ Link {:href selector-href
                         :target "_blank"
                         :sx #js {:color "primary.main"
                                  :textDecoration "none"
                                  "&:hover" #js {:textDecoration "underline"}}}
                   ($ Icon {:sx #js {:color "grey"}}
                      "open_in_new")))

             ;; Currently returning products
             ($ Typography {:variant "body2"
                            :color "text.secondary"}
                (str "Currently returning " (or total-products "Loading...") " products"))

             ;; Min products
             ($ Stack {:direction "row"
                       :spacing 1
                       :alignItems "center"}
                ($ Typography {:variant "body2"
                               :color "text.secondary"}
                   "Min products")
                ($ Typography {:variant "body2"
                               :color "text.primary"}
                   (str (:items-required placeholder)))))))))

(defui product-selector-editor [{:keys [selected-item] :as _props}]
  (let [ad-formats (-> selected-item :ad-variant :ad-formats)]
    ($ Stack {:spacing 2}
       ($ Stack {:spacing 2
                 :divider ($ Divider)
                 :sx #js {:p 2}}

          ($ Alert {:severity "info"
                    :sx #js {:mb 2}}
             "Ad variants will stop being served if the product selector returns fewer than the minimum product count.")

          (for [[index ad-format] (map-indexed vector ad-formats)]
            ($ ad-format-pane {:dynamic-content (:dynamic-content ad-format)
                               :key index}))))))
